import React from 'react';
import { Button } from '@mui/material';
import { COGNITO_CLIENT_ID, COGNITO_REDIRECT_SIGNIN_URL, COGNITO_USER_POOL_URL } from '../../config.js';
import PropTypes from 'prop-types';
import microsoft from 'assets/img/microsoft-logo.svg';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(() => ({
  loginBtn: {
    maxHeight: '38px',
  },
  icon: {
    backgroundImage: `url(${microsoft})`,
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    width: '32px',
    height: '32px',
    display: 'block',
    marginRight: '10px',
  },
}));

const OAuthButton = (props: any) => {
  const classes = useStyles();
  const handleClick = () => {
    window.location.assign(
      `https://${COGNITO_USER_POOL_URL}/oauth2/authorize?identity_provider=AzureAD&redirect_uri=${COGNITO_REDIRECT_SIGNIN_URL}/&response_type=TOKEN&client_id=${COGNITO_CLIENT_ID}`
    );
  };

  return (
    <Button onClick={handleClick} fullWidth={false} className={classes.loginBtn}>
      <span className={classes.icon} />
      {props.title}
    </Button>
  );
};

OAuthButton.propTypes = {
  brand: PropTypes.oneOf(['microsoft']),
};
export default OAuthButton;
